import { mount } from "@vue/test-utils";
import RadioItem from "@/components/core/custom/RadioItem";

describe("RadioItem component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(RadioItem);
  });

  it("Renders del component RadioItem", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
